export default "__VITE_ASSET__DhfKp$N3__"